import React from 'react';
import { Button } from 'ui-components/build';
import { useAuthentication } from '../context/AuthenticationProvider';
import { Currencies } from 'shared/build/enums';
import styled from 'styled-components';
import { useHistory, Redirect } from 'react-router-dom';
import { PaymentMethods } from 'shared/build/enums';

const ScButton = styled(Button)`
  min-width: 100px;
`;

const ScWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  min-height: 70%;
  align-content: center;

  p {
    margin-top: 40px;
  }
`;

const ScActions = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Checkout = () => {
  const { user } = useAuthentication();
  const history = useHistory();

  if (user?.currency === Currencies.Euro) {
    return <Redirect to={`/checkout/${PaymentMethods.StripePT}`} />;
  }

  return (
    <ScWrapper className="babys-page-padding">
      <h3 className="babys-cursive">
        O seu Cartão de Crédito é internacional?
      </h3>
      <ScActions>
        <ScButton
          onClick={() => history.push(`/checkout/${PaymentMethods.StripePT}`)}
        >
          Sim
        </ScButton>
        {user && user.currency === Currencies.BrazilianReal && (
          <ScButton
            onClick={() => history.push(`/checkout/${PaymentMethods.StripeBR}`)}
          >
            Não
          </ScButton>
        )}
      </ScActions>
      <p>
        Não se preocupe, o presente será em Reais e não haverá cobrança de IOF.
      </p>
    </ScWrapper>
  );
};
